import { render, staticRenderFns } from "./EmployeesGroupsConfigurations.vue?vue&type=template&id=f4b58a26&scoped=true"
import script from "./EmployeesGroupsConfigurations.vue?vue&type=script&lang=js"
export * from "./EmployeesGroupsConfigurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b58a26",
  null
  
)

export default component.exports